var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-breadcrumbs',{staticClass:"pl-0",attrs:{"items":_vm.breadCrumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"to":item.to,"exact":""}},[_vm._v(_vm._s(item.useI18n ? _vm.$t(item.text, { postfix: '' }) : item.text))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }